import {createAsyncThunk} from '@reduxjs/toolkit'

import {INTERNATIONAL_ONSITE_PAYMENT_HELP, PC_HELP} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

interface NavigateToCustomServiceParams extends NavigationTypeSelectableParam {
    /** 해외결제 여부 */
    isInternationalPayment: boolean
}

const navigateToCustomService = createAsyncThunk<NavigationResult, NavigateToCustomServiceParams, ThunkApi>(
    'navigateTo/customService',
    async ({isInternationalPayment}) => {
        const url = isInternationalPayment ? INTERNATIONAL_ONSITE_PAYMENT_HELP : PC_HELP

        if (isMobile) {
            changeBrowserLocation({
                url,
                type: 'PUSH',
            })

            return Promise.resolve()
        }

        openNewTab({url})
    },
)

export default navigateToCustomService
